import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    getAlsoPurchasedProductsCollectionV2,
    GetProductCollectionApiV2Parameter,
    getProductCollectionV2,
    GetRelatedProductCollectionApiV2Parameter,
    getRelatedProductsCollectionV2,
} from "@insite/client-framework/Services/ProductServiceV2";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { HasOnSuccess, replaceInChain,  createHandlerChainRunner,
    executeAwaitableHandlerChain,
    Handler,
    HasOnError,
    HasOnException, } from "@insite/client-framework/HandlerCreator";
import { RequestDataFromApi, chain } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";

import { StorefrontAccess } from "@insite/client-framework/Services/SettingsService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import isApiError from "@insite/client-framework/Common/isApiError";

type Parameter = (
    | GetProductCollectionApiV2Parameter
    | GetRelatedProductCollectionApiV2Parameter
    | GetAlsoPurchasedProductCollectionApiV2Parameter
) &
    HasOnSuccess<ProductModel[]> &
    HasOnError<string>;
type Props = {
    apiParameter:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;


export const RequestDataFromApiCustom: HandlerType = async props => {
    try {
        const state = props.getState();
        const currentPage = getCurrentPage(state);
        const settings = getSettingsCollection(state);
        if (
            settings.productSettings.storefrontAccess === StorefrontAccess.SignInRequiredToBrowse &&
            !state.context.session.isAuthenticated &&
            (currentPage.fields.excludeFromSignInRequired || currentPage.type === "SignInPage")
        ) {
            return false;
        }

        if ("relationship" in props.apiParameter) {
            props.apiResult = await getRelatedProductsCollectionV2(props.apiParameter);
        } else if ("productId" in props.apiParameter && props.apiParameter?.type === "alsoPurchased") {
            props.apiResult = await getAlsoPurchasedProductsCollectionV2(props.apiParameter);
        } else {
            const updatedParameter = JSON.parse(JSON.stringify(props.apiParameter));
            props.apiResult = await getProductCollectionV2({
                ...updatedParameter,
                searchWithin: updatedParameter?.searchWithin ? updatedParameter.searchWithin.replace(/%20/g, ' ') : ""
              });
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }

        throw error;
    }
};


replaceInChain(chain, RequestDataFromApi, RequestDataFromApiCustom);